<template>
  <div class="agent-container">
    <!-- Search and Stats Card -->
    <v-card class="search-card" elevation="2">
      <v-card-text>
        <v-row align="center">
          <v-col cols="12" md="4" sm="6">
            <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" label="חיפוש מספר" outlined dense
              hide-details background-color="white" class="search-field"></v-text-field>
          </v-col>
          <v-col cols="12" md="8" sm="6" class="d-flex align-center">
            <div class="numbers-count">
              <v-icon color="#0d2c6d" class="ml-2">mdi-phone</v-icon>
              <span>סך הכל <strong>{{ numbers.length }}</strong> מספרים</span>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Numbers Data Table Card -->
    <v-card class="data-table-card" elevation="2">
      <v-data-table id="table1" :headers="headers" :items="numbers" sort-by="createdAt" sort-desc :search="search"
        :footer-props="{
          'items-per-page-options': [20, 50, 100, 500, 1000],
          'items-per-page-text': 'שורות בעמוד:'
        }" class="numbers-table">
        <template v-if="$vuetify.breakpoint.mdAndUp" v-for="header in headers"
          v-slot:[`header.${header.value}`]="{ header }">
          <span class="table-header-text">{{ header.text }}</span>
        </template>

        <template v-if="$vuetify.breakpoint.mdAndUp" #item="{ item, index }">
          <tr class="table-row">
            <td class="table-cell">{{ index + 1 }}</td>
            <td class="table-cell">{{ item.line_number }}</td>
            <td class="table-cell">
              <v-chip small :color="getStatusColor(item.status)" text-color="white">
                {{ item.status }}
              </v-chip>
            </td>
            <td class="table-cell">
              <v-chip small color="#6a6aec" text-color="white">
                {{ item.type }}
              </v-chip>
            </td>
            <td class="table-cell">
              <div class="action-buttons">
                <!-- Action buttons would go here if needed -->
              </div>
            </td>
          </tr>
        </template>

        <template v-slot:no-data>
          <v-row v-if="progressShow" class="my-5">
            <v-col class="d-flex justify-center">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </v-col>
          </v-row>
          <div class="empty-state">
            <v-icon size="64" color="#0d2c6d">mdi-phone-off</v-icon>
            <span class="empty-text">אין עדיין מספרים</span>
            <v-btn color="primary" @click="refreshDetails()" class="mt-4">
              <v-icon left>mdi-refresh</v-icon>
              רענן
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- Dialogs -->
    <DeleteItemDialog v-model="deleteDialog" v-if="deleteDialog" :item="itemToDelete" @itemDeleted="itemDeleted">
    </DeleteItemDialog>

    <AddEditDialog v-model="addEditDialog" v-if="addEditDialog" :formTitle="formTitle" :itemToEdit="editedItem"
      @subscribeCreated="newSubscribeSaved" @subscribeEdited="editedSubscribeSaved"></AddEditDialog>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
  </div>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'
import Auth from '@/services/auth.service.js'
import DeleteItemDialog from '@/components/agent/dialogs/DeleteItemDialog'
import AddEditDialog from '@/components/agent/dialogs/AddEditDialog'

export default {
  components: {
    SnackBar,
    DeleteItemDialog,
    AddEditDialog
  },
  data: () => ({
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
    lineNumber: "",
    progressShow: false,
    addEditDialog: false,
    importDialog: false,
    importMessageDialog: false,
    importedFailed: [],
    importedSuccess: [],
    formTitle: "",
    itemToDelete: {},
    deleteDialog: false,
    search: "",
    numbers: [],
    headers: [
      { text: '#', value: "index", sortable: false, width: '50px' },
      { text: 'מספר', value: 'line_number', align: 'center' },
      { text: 'מצב', value: 'status', width: '150px', align: 'center' },
      { text: 'סוג', value: 'type', width: '120px', align: 'center' },
      { text: 'פעולות', value: 'actions', sortable: false, width: '100px' },
    ],
    editedItem: {},
  }),
  methods: {
    getStatusColor(status) {
      if (status.includes('מחובר')) {
        return '#4caf50'; // Green for connected
      } else {
        return '#ff9800'; // Orange for available
      }
    },

    async getNumbers() {
      try {
        this.progressShow = true;
        let token = localStorage.getItem("token");
        let api = process.env.VUE_APP_BASE_URL + `/agent_api/get_numbers_list`;
        const res = await fetch(api, ApiServices.requestOptions("GET", "", token));
        const jsonObject = await res.json();
        this.progressShow = true;
        if (res.status >= 400) {
          this.progressShow = true;
          this.showSnackBar("שגיאה בקבלת נתונים", "red");
        } else if (res.status === 200) {
          this.numbers = jsonObject;
          this.progressShow = false;
          this.formatDetails();
        }
      } catch (error) {
        this.showSnackBar("Error get subscribes: " + error, "red");
      }
    },
    formatDetails() {
      this.numbers = this.numbers.map((number) => {
        // Check if the active_user property is not empty
        let statusValue = number.user_active ? `מחובר למשתמש ${number.user_active}` : 'פנוי';

        return {
          ...number,
          status: statusValue, // Set the status based on the condition
        };
      });
    },
    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true;
    },
    openDeleteDialog(item, index) {
      this.itemToDelete = item;
      this.deleteDialog = true;
    },
    openEditDialog(item, index) {
      this.formTitle = "ערוך איש קשר";
      this.editedItem = item;
      this.editedItem.itemIndex = index;
      this.addEditDialog = true;
    },
    openCreateDIalog() {
      this.formTitle = "הוספת איש קשר חדש:";
      this.editedItem = {};
      this.addEditDialog = true;
    },
    newSubscribeSaved(item, text, color) {
      this.showSnackBar(text, color);
      if (item === "") {
        return;
      }
      this.numbers.push(item);
    },
    editedSubscribeSaved(item, text, color) {
      this.showSnackBar(text, color);
      if (item === "") {
        return;
      }
      const index = this.numbers.findIndex(number => number._id === item._id);
      let g = Object.assign(this.numbers[index], item);
    },
    itemDeleted(id, text, color) {
      if (id === "") {
        this.showSnackBar(text, color);
        return;
      }
      // Use splice to remove the item at the specified index
      const index = this.numbers.findIndex(number => number._id === id);
      this.numbers.splice(index, 1);
      this.showSnackBar(text, color);
    },
    refreshDetails() {
      this.getNumbers();
    }
  },
  mounted() {
    this.lineNumber = Auth.getLineNumber();
    this.getNumbers();
  },
}
</script>

<style scoped>
.agent-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
  direction: rtl;
  font-family: 'Heebo', sans-serif;
}

.search-card {
  margin-bottom: 24px;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.search-card:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1) !important;
}

.search-field {
  border-radius: 8px;
}

.numbers-count {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #0d2c6d;
}

.data-table-card {
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  margin-bottom: 40px;
}

.data-table-card:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1) !important;
}

.numbers-table {
  width: 100%;
}

.table-header-text {
  font-size: 16px;
  font-weight: 600;
  color: #0d2c6d;
}

.table-row {
  height: 60px !important;
  transition: background-color 0.2s ease;
}

.table-row:hover {
  background-color: rgba(13, 44, 109, 0.05) !important;
}

.table-cell {
  font-size: 14px;
  color: #333;
  text-align: center !important;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 0;
}

.empty-text {
  font-size: 20px;
  font-weight: 600;
  color: #0d2c6d;
  margin-top: 16px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .agent-container {
    padding: 0 12px;
  }

  .table-header-text {
    font-size: 14px;
  }

  .table-cell {
    font-size: 13px;
  }
}

@media (max-width: 600px) {

  .search-card,
  .data-table-card {
    border-radius: 8px;
  }

  .numbers-count {
    justify-content: center;
    margin-top: 8px;
  }
}

#table1.v-data-table>>> .v-data-table-header th {
    background-color: rgba(0, 0, 0, 0.116) !important;
    border-left: 1px solid white !important;
}
</style>